<template>
  <div>
    <back-button />
    <page-header>{{ user.name }}</page-header>
    <user-form :user="user" :self="true" @submit="submitForm" />
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import UserForm from "../components/UserForm";
import BackButton from "../components/BackButton";
import PageHeader from "../components/PageHeader";
import store from "../store";

export default {
  name: "partner",
  components: {
    UserForm,
    BackButton,
    PageHeader
  },
  computed: {
    user() {
      return store.currentUser;
    }
  },
  methods: {
    submitForm(user) {
      // сбрасываем пароль если введены пароль и код
      if (user.password && user.code) {
        this.loading = true;
        axios
          .post(api.restore, {
            id: user.id,
            password: user.password,
            code: user.code
          })
          .then(() => {
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Пароль обновлён";
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarSuccess = false;
            store.snackbarMessage = err.message;
          })
          .finally(() => {
            this.loading = false;
          });
      }

      this.loading = true;
      axios
        .put(api.usersettings, {
          id: user.id,
          name: user.name
        })
        .then(resp => {
          store.currentUser = resp.data;
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Данные обновлены";
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
